export const fetchAddress = async postcode => {
  return await window.$vue.$get({
    endpoint: `/city/postcode/${postcode}`,
    encrypt: false
  })
}
export const fetchAddressGroups = async params => {
  return await window.$vue.$get({
    endpoint: `/address/consult-group`,
    params,
    encrypt: false
  })
}
export const saveAddress = async data => {
  return await window.$vue.$post({ endpoint: "/address", data })
}
export const listCities = async payload => {
  return await window.$vue.$get({ endpoint: `/city/state/${payload}` })
}

export const fetchAddressComplements = async () => {
  return await window.$vue.$get({
    endpoint: "/provider/complement"
  })
}

export const fetchAddressByUserPosition = async params => {
  return await window.$vue.$get({
    endpoint: "/address/coordinates",
    params
  })
}

export const fetchCondominiumOptions = async params => {
  return await window.$vue.$get({
    endpoint: "/sale/condominiums",
    params
  })
}

export const fetchAllCondominiumOptions = async params => {
  return await window.$vue.$get({
    endpoint: "/sale/list-condominiums",
    params
  })
}